import apiClient from './apiClient'
import type { CutoffsPayload } from '@/types'

interface CutoffsResponse {
  success: boolean
  message: string
  data: CutoffsPayload
}

class CutoffsService {
  async getCutoffs(): Promise<CutoffsPayload> {
    const response = await apiClient.get('/api/auth/cutoffs')
    return (response as unknown as CutoffsResponse).data
  }
}

export default new CutoffsService()
